// core
import { API_METHOD } from 'config';
import { getTheme } from '_core/themes/getTheme';

export const sendTheme = (request, create) => {
  const version = String(Date.now());
  
  const sendTheme = (data, name, photo_data) => {
    console.log('send theme', name, '...');
    
    const method = create ? API_METHOD.THEME_CREATE : API_METHOD.THEME_UPDATE;

    const theme = getTheme(data);
    
    theme.version = version;
    
    return request.send(method, {
      name,
      title: theme.themeName,
      content: JSON.stringify(theme),
      version,
      photo_data,
      
      is_active: true
    });
  };

  const updateThemes = async (create) => {
    try {
      const lightTheme = await import(`${process.env.REACT_APP_PROJECT}/themes/light`);
      const darkTheme = await import(`${process.env.REACT_APP_PROJECT}/themes/dark`);

      await sendTheme(lightTheme, 'light', 'brightness_7');
      await sendTheme(darkTheme, 'dark', 'brightness_4');

      process.env.NODE_ENV !== 'production' && console.log(`=== Themes ${create ? 'created' : 'updated'}! ===`);
    } catch (error) {
      process.env.NODE_ENV !== 'production' && console.error(`=== Themes ${create ? 'creation' : 'update'} failed! ===`, error);
    }
  };
  
  return updateThemes();
};
